export default "__VITE_ASSET__D6ZV6eqo__"